import Checkout from './Checkout'
import ProductsCheckout from './ProductsCheckout'
import EmployeeCheckout from './EmployeeCheckout'

export default {
    'checkout': Checkout,
    'products-checkout': ProductsCheckout,
    'employee-checkout': EmployeeCheckout,
}
